export enum InvoiceCreditNoteStatus {
  PROCESSING = 'PROCESSING',
  AWAITING_CREATE = 'AWAITING_CREATE',
  ACCEPTED = 'ACCEPTED',
}
